import {Component, ViewChild} from '@angular/core';
import {
    AlertController, IonicPage, LoadingController, ModalController, NavController, NavParams,
    Platform, Toast, ToastController
} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";
import {SocialSharing} from "@ionic-native/social-sharing";

@Component({
    selector: 'page-contact',
    templateUrl: 'contact.html',
})
export class ContactPage {

    School = 'GEIS';
    SchoolData = {};

    ErpStandard = 'All';
    ErpStandardData = {};

    data = 'Admissions';

    AcademicYear: any;
    AcademicYearData: any;

    AdmissionData = [];
    EnquiryData = [];
    WwgsEnquiryData = [];
    datanotfound: any;
    DataSearch: any;

    StdCount_0: any;
    StdCount_1: any;
    StdCount_2: any;
    StdCount_3: any;
    StdCount_4: any;
    StdCount_5: any;
    StdCount_6: any;
    StdCount_7: any;

    StdAllCount:any;
    StdPGCount:any;
    StdNurCount:any;
    StdJrCount:any;
    StdSrCount:any;
    Std1Count:any;
    Std2Count:any;
    Std3Count:any;
    Std4Count:any;
    Std5Count:any;
    Std6Count:any;
    Std7Count:any;

    IsSearch = 0;
    Page = 1;

    Standard = 'All';
    StandardData = {};

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public platform: Platform,
                private socialSharing: SocialSharing,
                public service: ServiceProvider,
                public alertCtrl: AlertController,
                public loadingCtrl: LoadingController,
                public modalCtrl: ModalController,
                public toastCtrl: ToastController) {
        this.platform.ready().then(() => {

            this.SchoolData = {
                "GWW": 2,
                "GWE": 3,
                "GEIS": 1
            };

            this.StandardData = {
                "All": 0,
                "P": 1,
                "N": 2,
                "J": 3,
                "S": 4,
                "1": 5,
                "2": 6,
                "3": 7,
                "4": 8,
                "5": 9,
                "6": 10,
                "7": 11,
            }

            this.loadAcademicYearData(this.SchoolData[this.School]);

            this.ErpStandardData = {
                "All": 0,
                "1": 1,
                "2": 2,
                "3": 3,
                "4": 4,
                "5": 5,
                "6": 6,
                "7": 7
            }
        })
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad ContactPage');
    }

    active_School_tab(tab) {
        console.log(tab);
        this.School = tab;
        // this.active_tab(this.Standard);
        this.loadAcademicYearData(this.SchoolData[this.School]);
    }



    loadAcademicYearData(SchoolId) {
        this.service.httpcall('web_service/get_academic_year_by_school_id?FSchoolId=' + SchoolId).subscribe(data => {
            console.log(data);
            this.AcademicYearData = data;
            let AcademicYearDataCount = this.AcademicYearData.length;
            console.log(AcademicYearDataCount);
            this.AcademicYear = this.AcademicYearData[0]['Id'];
            console.log("Id", this.AcademicYear);
            this.getStudents();
        })
    }

    getStudents() {
        this.DataSearch = null;
        this.AdmissionData = [];
        this.EnquiryData = [];
        this.EnquiryData = [];
        this.Page = 1;
        this.IsSearch = 0;
        if (this.data == 'Admissions') {
            this.active_erp_standard_tab(this.ErpStandard);
        }
        if (this.data == 'Enquiry') {
            this.active_erp_standard_tab(this.ErpStandard);
        }
        if (this.data == 'Data') {
            this.active_standard_tab(this.ErpStandard);
        }
    }

    active_data_tab(tab) {
        console.log(tab);
        this.data = tab;
        if (this.data == 'Admissions') {
            this.active_erp_standard_tab(this.ErpStandard);
        }
        if (this.data == 'Enquiry') {
            this.active_erp_standard_tab(this.ErpStandard);
        }
        if (this.data == 'Data') {
            this.active_standard_tab(this.ErpStandard);
        }
    }

    active_erp_standard_tab(tab) {
        console.log(tab);
        this.ErpStandard = tab;
        this.DataSearch = null;
        this.AdmissionData = [];
        this.EnquiryData = [];
        this.Page = 1;
        this.IsSearch = 0;
        if (this.data == 'Admissions') {
            this.loadvalues(this.SchoolData[this.School], this.ErpStandardData[this.ErpStandard], this.AcademicYear, this.Page);
            this.loadCountvalues(this.SchoolData[this.School], this.AcademicYear);
        }
        if (this.data == 'Enquiry') {
            this.loadEnqvalues(this.SchoolData[this.School], this.ErpStandardData[this.ErpStandard], this.AcademicYear, this.Page);
            this.loadEngCountvalues(this.SchoolData[this.School], this.AcademicYear);
        }
    }

    active_standard_tab(tab) {
        console.log(tab);
        this.Standard = tab;
        this.DataSearch = null;
        this.WwgsEnquiryData = [];
        this.Page = 1;
        this.IsSearch = 0;
        console.log(this.StandardData[this.Standard]);
        this.loadDataCountvalues();
        this.loadDatavalues(this.SchoolData[this.School], this.StandardData[this.Standard], this.Page);
    }



    loadvalues(SchoolId, Standard, FAcademicYearId, page) {
        this.datanotfound = null;

        this.service.httpcall('app_web_service/get_contact_students_from_admission?FSchoolId=' + SchoolId + '&FAcademicYearId=' + FAcademicYearId + '&Standard=' + Standard + '&Page=' + page).subscribe(data => {
            console.log(data);
            if (data['response'] == "success") {
                for (let i = 0; i < data['Data'].length; i++) {
                    this.AdmissionData.push(data['Data'][i]);
                }
            } else {
                this.datanotfound = data['error_description'];
            }
        })
    }

    loadEnqvalues(SchoolId, Standard, FAcademicYearId, page) {
        this.datanotfound = null;

        this.service.httpcall('app_web_service/get_contact_students_from_school_enquiry?FSchoolId=' + SchoolId + '&FAcademicYearId=' + FAcademicYearId + '&Standard=' + Standard + '&Page=' + page).subscribe(data => {
            console.log(data);
            if (data['response'] == "success") {
                for (let i = 0; i < data['Data'].length; i++) {
                    this.EnquiryData.push(data['Data'][i]);
                }
            } else {
                this.datanotfound = data['error_description'];
            }
        })
    }

    loadDatavalues(SchoolId, Standard, page) {
        this.datanotfound = null;

        this.service.httpcall('app_web_service/get_contact_students_from_data?FSchoolId=' + SchoolId + '&Standard=' + Standard + '&Page=' + page).subscribe(data => {
            console.log(data);
            if (data['response'] == "success") {
                for (let i = 0; i < data['Data'].length; i++) {
                    this.WwgsEnquiryData.push(data['Data'][i]);
                }
            } else {
                this.datanotfound = data['error_description'];
            }
        })
    }

    doInfinite(infiniteScroll) {
        if (this.IsSearch == 0) {
            console.log('Begin async operation');

            this.Page = this.Page + 1;
            console.log("page number ", this.Page);
            if (this.data == 'Admissions') {
                this.loadvalues(this.SchoolData[this.School], this.ErpStandardData[this.ErpStandard], this.AcademicYear, this.Page);
            }
            if (this.data == 'Enquiry') {
                this.loadEnqvalues(this.SchoolData[this.School], this.ErpStandardData[this.ErpStandard], this.AcademicYear, this.Page);
            }
            if (this.data == 'Data') {
                this.loadDatavalues(this.SchoolData[this.School], this.StandardData[this.Standard], this.Page);
            }

        }
        setTimeout(() => {
            // for (let i = 0; i < 30; i++) {
            //   this.items.push( this.items.length );
            // }
            console.log('Async operation has ended');
            infiniteScroll.complete();
        }, 500);
    }

    loadCountvalues(School, FAcademicYearId) {
        this.service.httpcall('web_service/get_erp_admission_count?FSchoolId=' + School + '&FAcademicYearId=' + FAcademicYearId).subscribe(data => {
            console.log(data);
            this.StdCount_0 = data[0]['StdCount_0'];
            this.StdCount_1 = data[1]['StdCount_1'];
            this.StdCount_2 = data[2]['StdCount_2'];
            this.StdCount_3 = data[3]['StdCount_3'];
            this.StdCount_4 = data[4]['StdCount_4'];
            this.StdCount_5 = data[5]['StdCount_5'];
            this.StdCount_6 = data[6]['StdCount_6'];
            this.StdCount_7 = data[7]['StdCount_7'];
        })
    }

    loadEngCountvalues(School, FAcademicYearId) {
        this.service.httpcall('web_service/get_erp_enquiry_count?FSchoolId=' + School + '&FAcademicYearId=' + FAcademicYearId).subscribe(data => {
            console.log(data);
            this.StdCount_0 = data[0]['StdCount_0'];
            this.StdCount_1 = data[1]['StdCount_1'];
            this.StdCount_2 = data[2]['StdCount_2'];
            this.StdCount_3 = data[3]['StdCount_3'];
            this.StdCount_4 = data[4]['StdCount_4'];
            this.StdCount_5 = data[5]['StdCount_5'];
            this.StdCount_6 = data[6]['StdCount_6'];
            this.StdCount_7 = data[7]['StdCount_7'];
        })
    }

    loadDataCountvalues() {

        this.service.httpcall('web_service/get_standardCount_web_enquiry?FSchoolId='+this.SchoolData[this.School]).subscribe(data => {
            console.log(data);
            this.StdAllCount=data['StdAllCount'];
            this.StdPGCount=data['StdPGCount'];
            this.StdNurCount=data['StdNurCount'];
            this.StdJrCount=data['StdJrCount'];
            this.StdSrCount=data['StdSrCount'];
            this.Std1Count=data['Std1Count'];
            this.Std2Count=data['Std2Count'];
            this.Std3Count=data['Std3Count'];
            this.Std4Count=data['Std4Count'];
            this.Std5Count=data['Std5Count'];
            this.Std6Count=data['Std6Count'];
            this.Std7Count=data['Std7Count'];
        });
    }

    searchData() {
        this.IsSearch = 1;
        let loading = this.loadingCtrl.create({
            content: 'Loading'
        });
        loading.present();
        setTimeout(() => {
            loading.dismiss();
        }, 5000);

        console.log("Search:", this.DataSearch);
        this.AdmissionData = [];
        this.EnquiryData = [];
        this.WwgsEnquiryData = [];
        this.datanotfound = null;

        if (this.data == 'Admissions') {
            this.service.httpcall('app_web_service/search_contact_students_from_admission?FSchoolId=' + this.SchoolData[this.School] + '&FAcademicYearId=' + this.AcademicYear + '&Standard=' + this.ErpStandardData[this.ErpStandard] + '&Search=' + this.DataSearch).subscribe(data => {
                if (loading)
                    loading.dismiss();
                loading = undefined;
                console.log(data);
                if (data['response'] == "success") {
                    if (loading)
                        loading.dismiss();
                    loading = undefined;
                    this.datanotfound = null;
                    this.AdmissionData = data['Data'];
                } else {
                    if (loading)
                        loading.dismiss();
                    loading = undefined;
                    this.datanotfound = data['error_description'];
                }

            })
        }
        if (this.data == 'Enquiry') {
            this.service.httpcall('app_web_service/search_contact_students_from_enquiry?FSchoolId=' + this.SchoolData[this.School] + '&FAcademicYearId=' + this.AcademicYear + '&Standard=' + this.ErpStandardData[this.ErpStandard] + '&Search=' + this.DataSearch).subscribe(data => {
                if (loading)
                    loading.dismiss();
                loading = undefined;
                console.log(data);
                if (data['response'] == "success") {
                    if (loading)
                        loading.dismiss();
                    loading = undefined;
                    this.datanotfound = null;
                    this.EnquiryData = data['Data'];
                } else {
                    if (loading)
                        loading.dismiss();
                    loading = undefined;
                    this.datanotfound = data['error_description'];
                }

            })
        }
        if (this.data == 'Data') {
            this.service.httpcall('app_web_service/search_contact_students_from_data?FSchoolId=' + this.SchoolData[this.School] + '&Standard=' + this.StandardData[this.Standard] + '&Search=' + this.DataSearch).subscribe(data => {
                if (loading)
                    loading.dismiss();
                loading = undefined;
                console.log(data);
                if (data['response'] == "success") {
                    if (loading)
                        loading.dismiss();
                    loading = undefined;
                    this.datanotfound = null;
                    this.WwgsEnquiryData = data['Data'];
                } else {
                    if (loading)
                        loading.dismiss();
                    loading = undefined;
                    this.datanotfound = data['error_description'];
                }

            })
        }


    }

    call(item, attr) {
        let phone = null;
        if (attr == 'Phone1') {
            phone = item.Phone1;
        } else if (attr == 'Phone2') {
            phone = item.Phone2;
        } else if (attr == 'PrimaryContact') {
            phone = item.PrimaryContact;
        } else if (attr == 'FatherMobile') {
            phone = item.FatherMobile;
        } else if (attr == 'MotherMobile') {
            phone = item.MotherMobile;
        } else if (attr == 'FatherPhone') {
            phone = item.FatherPhone;
        } else if (attr == 'MotherPhone') {
            phone = item.MotherPhone;
        }
        console.log("call ->", phone);
        window.location.href = 'tel:' + phone;
    }
    whatsapp(item, attr) {
        let phone = null;
        if (attr == 'Phone1') {
            phone = item.Phone1;
        } else if (attr == 'Phone2') {
            phone = item.Phone2;
        } else if (attr == 'PrimaryContact') {
            phone = item.PrimaryContact;
        } else if (attr == 'FatherMobile') {
            phone = item.FatherMobile;
        } else if (attr == 'MotherMobile') {
            phone = item.MotherMobile;
        } else if (attr == 'FatherPhone') {
            phone = item.FatherPhone;
        } else if (attr == 'MotherPhone') {
            phone = item.MotherPhone;
        }
        console.log("whatsapp ->", phone);
        window.location.href = 'whatsapp://send?phone=+91' + phone;
    }
    checkwhatsapp(item, attr,index) {
        console.log(attr);
        let phone = null;
        let DataFrom = null;
        let Id = null;
        if (attr == 'Phone1') {
            phone = item.Phone1;
            DataFrom = 1;
            Id = item.FWebEnquiryId;
        } else if (attr == 'Phone2') {
            phone = item.Phone2;
            DataFrom = 1;
            Id = item.FWebEnquiryId;
        } else if (attr == 'PrimaryContact') {
            phone = item.PrimaryContact;
            DataFrom = 2;
            Id = item.FAdmissionId;
        } else if (attr == 'FatherMobile') {
            phone = item.FatherMobile;
            DataFrom = 2;
            Id = item.FAdmissionId;
        } else if (attr == 'MotherMobile') {
            phone = item.MotherMobile;
            DataFrom = 2;
            Id = item.FAdmissionId;
        } else if (attr == 'FatherPhone') {
            phone = item.FatherPhone;
            DataFrom = 2;
            Id = item.FAdmissionId;
        } else if (attr == 'MotherPhone') {
            phone = item.MotherPhone;
            DataFrom = 2;
            Id = item.FAdmissionId;
        }
        console.log("checkwhatsapp ->", phone);
        console.log("DataFrom ->", DataFrom);
        console.log("Id ->", Id);


        let myAlert = this.alertCtrl.create({
            title: 'Check WhatsApp',
            buttons: [
                {
                    text: 'No',
                    role: 'No',
                    handler: (data) => {
                        console.log('No Message clicked');
                        let CheckWhatsApp = 2;
                        this.service.httpcall('app_web_service/check_whatsapp_by_schoolId?SchoolId=' + this.SchoolData[this.School] + '&DataFrom=' + DataFrom + '&Id=' + Id + '&PhoneType=' + attr + '&CheckWhatsApp=' + CheckWhatsApp).subscribe(data => {
                            console.log(data);
                            if (data['response'] == "success") {
                                this.presentToast(data['message']);
                                console.log("LabelId->",index+"_"+attr," CSS->",this.get_whatsAppCheck_color(1));
                                var element1 = <HTMLInputElement> document.getElementById(index+"_"+attr);
                                element1.style.background = '#ef5350';
                                // this.AdmissionData = [];
                                // this.Page = 1;
                                // this.IsSearch = 0;
                                // this.loadvalues(this.SchoolData[this.School], this.ErpStandardData[this.ErpStandard], this.AcademicYear, this.Page);
                            } else {
                                this.presentToast(data['error_description']);
                            }
                        })
                    }
                },
                {
                    text: 'Yes',
                    role: 'Yes',
                    handler: (data) => {
                        console.log('Yes Message clicked');
                        let CheckWhatsApp = 1;
                        this.service.httpcall('app_web_service/check_whatsapp_by_schoolId?SchoolId=' + this.SchoolData[this.School] + '&DataFrom=' + DataFrom + '&Id=' + Id + '&PhoneType=' + attr + '&CheckWhatsApp=' + CheckWhatsApp).subscribe(data => {
                            console.log(data);
                            if (data['response'] == "success") {
                                this.presentToast(data['message']);
                                console.log("LabelId->",index+"_"+attr," CSS->",this.get_whatsAppCheck_color(1));
                                var element2 = <HTMLInputElement> document.getElementById(index+"_"+attr);
                                element2.style.background = '#66bb6a';//this.get_whatsAppCheck_color(1);

                                // this.AdmissionData = [];
                                // this.Page = 1;
                                // this.IsSearch = 0;
                                // this.loadvalues(this.SchoolData[this.School], this.ErpStandardData[this.ErpStandard], this.AcademicYear, this.Page);
                            } else {
                                this.presentToast(data['error_description']);
                            }
                        })
                    }
                }
            ]
        });

        myAlert.present();

    }
    edit(item, attr,index) {
        let phone = null;
        let DataFrom = null;
        let Id = null;
        if (attr == 'Phone1') {
            phone = item.Phone1;
            DataFrom = 1;
            Id = item.FWebEnquiryId;
        } else if (attr == 'Phone2') {
            phone = item.Phone2;
            DataFrom = 1;
            Id = item.FWebEnquiryId;
        } else if (attr == 'PrimaryContact') {
            phone = item.PrimaryContact;
            DataFrom = 2;
            Id = item.FAdmissionId;
        } else if (attr == 'FatherMobile') {
            phone = item.FatherMobile;
            DataFrom = 2;
            Id = item.FAdmissionId;
        } else if (attr == 'MotherMobile') {
            phone = item.MotherMobile;
            DataFrom = 2;
            Id = item.FAdmissionId;
        } else if (attr == 'FatherPhone') {
            phone = item.FatherPhone;
            DataFrom = 2;
            Id = item.FAdmissionId;
        } else if (attr == 'MotherPhone') {
            phone = item.MotherPhone;
            DataFrom = 2;
            Id = item.FAdmissionId;
        }
        console.log("checkwhatsapp ->", phone);
        console.log("DataFrom ->", DataFrom);
        console.log("Id ->", Id);

        let myAlert = this.alertCtrl.create({
            title: 'Edit Number',
            buttons: [
                {
                    text: 'Submit',
                    role: 'Submit',
                    handler: (data) => {
                        console.log(data[0], ' Message clicked');
                        let PhoneNumber = data[0];
                        this.service.httpcall('app_web_service/edit_phone_number_by_schoolId?SchoolId=' + this.SchoolData[this.School] + '&DataFrom=' + DataFrom + '&Id=' + Id + '&PhoneType=' + attr + '&PhoneNumber=' + PhoneNumber).subscribe(data => {
                            console.log(data);
                            if (data['response'] == "success") {
                                this.presentToast(data['message']);
                                var element=<HTMLInputElement> document.getElementById(index+"_"+attr+"_Et") ;
                                element.innerHTML=PhoneNumber;
                                // this.AdmissionData = [];
                                // this.Page = 1;
                                // this.IsSearch = 0;
                                // this.loadvalues(this.SchoolData[this.School], this.ErpStandardData[this.ErpStandard], this.AcademicYear, this.Page);
                            } else {
                                this.presentToast(data['error_description']);
                            }
                        })
                    }
                }
            ]
        });

        myAlert.addInput({
            type: 'text',
            label: attr,
            value: phone
        });

        myAlert.present();


    }

    Enqcall(item, attr) {
        let phone = null;
        if (attr == 'Phone1') {
            phone = item.Phone1;
        } else if (attr == 'Phone2') {
            phone = item.Phone2;
        } else if (attr == 'Mobile') {
            phone = item.Mobile;
        } else if (attr == 'MotherContact') {
            phone = item.MotherContact;
        }
        console.log("call ->", phone);
        window.location.href = 'tel:' + phone;
    }
    Enqwhatsapp(item, attr) {
        let phone = null;
        if (attr == 'Phone1') {
            phone = item.Phone1;
        } else if (attr == 'Phone2') {
            phone = item.Phone2;
        } else if (attr == 'PrimaryContact') {
            phone = item.PrimaryContact;
        } else if (attr == 'Mobile') {
            phone = item.Mobile;
        } else if (attr == 'MotherContact') {
            phone = item.MotherContact;
        }
        console.log("whatsapp ->", phone);
        window.location.href = 'whatsapp://send?phone=+91' + phone;
    }
    Enqcheckwhatsapp(item, attr,index) {
        console.log(attr);
        let phone = null;
        let DataFrom = null;
        let Id = null;
        if (attr == 'Phone1') {
            phone = item.Phone1;
            DataFrom = 1;
            Id = item.FWebEnquiryId;
        } else if (attr == 'Phone2') {
            phone = item.Phone2;
            DataFrom = 1;
            Id = item.FWebEnquiryId;
        } else if (attr == 'Mobile') {
            phone = item.Mobile;
            DataFrom = 2;
            Id = item.FEnquiryId;
        } else if (attr == 'MotherContact') {
            phone = item.MotherContact;
            DataFrom = 2;
            Id = item.FEnquiryId;
        }
        console.log("checkwhatsapp ->", phone);
        console.log("DataFrom ->", DataFrom);
        console.log("Id ->", Id);


        let myAlert = this.alertCtrl.create({
            title: 'Check WhatsApp',
            buttons: [
                {
                    text: 'No',
                    role: 'No',
                    handler: (data) => {
                        console.log('No Message clicked');
                        let CheckWhatsApp = 2;
                        this.service.httpcall('app_web_service/check_whatsapp_by_schoolId_enquiry?SchoolId=' + this.SchoolData[this.School] + '&DataFrom=' + DataFrom + '&Id=' + Id + '&PhoneType=' + attr + '&CheckWhatsApp=' + CheckWhatsApp).subscribe(data => {
                            console.log(data);
                            if (data['response'] == "success") {
                                this.presentToast(data['message']);
                                console.log("LabelId->",index+"_"+attr," CSS->",this.get_whatsAppCheck_color(1));
                                var element1 = <HTMLInputElement> document.getElementById(index+"_"+attr);
                                element1.style.background = '#ef5350';

                                // this.EnquiryData = [];
                                // this.Page = 1;
                                // this.IsSearch = 0;
                                // this.loadEnqvalues(this.SchoolData[this.School], this.ErpStandardData[this.ErpStandard], this.AcademicYear, this.Page);
                            } else {
                                this.presentToast(data['error_description']);
                            }
                        })
                    }
                },
                {
                    text: 'Yes',
                    role: 'Yes',
                    handler: (data) => {
                        console.log('Yes Message clicked');
                        let CheckWhatsApp = 1;
                        this.service.httpcall('app_web_service/check_whatsapp_by_schoolId_enquiry?SchoolId=' + this.SchoolData[this.School] + '&DataFrom=' + DataFrom + '&Id=' + Id + '&PhoneType=' + attr + '&CheckWhatsApp=' + CheckWhatsApp).subscribe(data => {
                            console.log(data);
                            if (data['response'] == "success") {
                                this.presentToast(data['message']);
                                console.log(index+"_"+attr);
                                var element2 = <HTMLInputElement> document.getElementById(index+"_"+attr);
                                element2.style.background = '#66bb6a';
                                // this.EnquiryData = [];
                                // this.Page = 1;
                                // this.IsSearch = 0;
                                // this.loadEnqvalues(this.SchoolData[this.School], this.ErpStandardData[this.ErpStandard], this.AcademicYear, this.Page);
                            } else {
                                this.presentToast(data['error_description']);
                            }
                        })
                    }
                }
            ]
        });

        myAlert.present();

    }
    Enqedit(item, attr,index) {
        let phone = null;
        let DataFrom = null;
        let Id = null;
        if (attr == 'Phone1') {
            phone = item.Phone1;
            DataFrom = 1;
            Id = item.FWebEnquiryId;
        } else if (attr == 'Phone2') {
            phone = item.Phone2;
            DataFrom = 1;
            Id = item.FWebEnquiryId;
        } else if (attr == 'Mobile') {
            phone = item.Mobile;
            DataFrom = 2;
            Id = item.FEnquiryId;
        } else if (attr == 'MotherContact') {
            phone = item.MotherContact;
            DataFrom = 2;
            Id = item.FEnquiryId;
        }
        console.log("checkwhatsapp ->", phone);
        console.log("DataFrom ->", DataFrom);
        console.log("Id ->", Id);

        let myAlert = this.alertCtrl.create({
            title: 'Edit Number',
            buttons: [
                {
                    text: 'Submit',
                    role: 'Submit',
                    handler: (data) => {
                        console.log(data[0], ' Message clicked');
                        let PhoneNumber = data[0];
                        this.service.httpcall('app_web_service/edit_phone_number_by_schoolId_enquiry?SchoolId=' + this.SchoolData[this.School] + '&DataFrom=' + DataFrom + '&Id=' + Id + '&PhoneType=' + attr + '&PhoneNumber=' + PhoneNumber).subscribe(data => {
                            console.log(data);
                            if (data['response'] == "success") {
                                this.presentToast(data['message']);
                                var element=<HTMLInputElement> document.getElementById(index+"_"+attr+"_Et") ;
                                element.innerHTML=PhoneNumber;
                                // this.EnquiryData = [];
                                // this.Page = 1;
                                // this.IsSearch = 0;
                                // this.loadEnqvalues(this.SchoolData[this.School], this.ErpStandardData[this.ErpStandard], this.AcademicYear, this.Page);
                            } else {
                                this.presentToast(data['error_description']);
                            }
                        })
                    }
                }
            ]
        });

        myAlert.addInput({
            type: 'text',
            label: attr,
            value: phone
        });

        myAlert.present();


    }

    Datacall(item, attr) {
        let phone = null;
        if (attr == 'Phone1') {
            phone = item.Phone1;
        } else if (attr == 'Phone2') {
            phone = item.Phone2;
        } else if (attr == 'PrimaryContact') {
            phone = item.PrimaryContact;
        } else if (attr == 'FatherMobile') {
            phone = item.FatherMobile;
        } else if (attr == 'MotherMobile') {
            phone = item.MotherMobile;
        } else if (attr == 'FatherPhone') {
            phone = item.FatherPhone;
        } else if (attr == 'MotherPhone') {
            phone = item.MotherPhone;
        } else if (attr == 'MotherContact') {
            phone = item.MotherContact;
        } else if (attr == 'Mobile') {
            phone = item.Mobile;
        }
        console.log("call ->", phone);
        window.location.href = 'tel:' + phone;
    }
    Datawhatsapp(item, attr) {
        let phone = null;
        if (attr == 'Phone1') {
            phone = item.Phone1;
        } else if (attr == 'Phone2') {
            phone = item.Phone2;
        } else if (attr == 'PrimaryContact') {
            phone = item.PrimaryContact;
        } else if (attr == 'FatherMobile') {
            phone = item.FatherMobile;
        } else if (attr == 'MotherMobile') {
            phone = item.MotherMobile;
        } else if (attr == 'FatherPhone') {
            phone = item.FatherPhone;
        } else if (attr == 'MotherPhone') {
            phone = item.MotherPhone;
        } else if (attr == 'MotherContact') {
            phone = item.MotherContact;
        } else if (attr == 'Mobile') {
            phone = item.Mobile;
        }
        console.log("whatsapp ->", phone);
        window.location.href = 'whatsapp://send?phone=+91' + phone;
    }
    Datacheckwhatsapp(item, attr,index) {
        console.log(attr);
        let phone = null;
        let DataFrom = null;
        let Id = null;
        if (attr == 'Phone1') {
            phone = item.Phone1;
            DataFrom = 1;
            Id = item.Id;
        } else if (attr == 'Phone2') {
            phone = item.Phone2;
            DataFrom = 1;
            Id = item.Id;
        }

        else if (attr == 'PrimaryContact') {
            phone = item.PrimaryContact;
            DataFrom = 2;
            Id = item.FAdmissionId;
        } else if (attr == 'FatherMobile') {
            phone = item.FatherMobile;
            DataFrom = 2;
            Id = item.FAdmissionId;
        } else if (attr == 'MotherMobile') {
            phone = item.MotherMobile;
            DataFrom = 2;
            Id = item.FAdmissionId;
        } else if (attr == 'FatherPhone') {
            phone = item.FatherPhone;
            DataFrom = 2;
            Id = item.FAdmissionId;
        } else if (attr == 'MotherPhone') {
            phone = item.MotherPhone;
            DataFrom = 2;
            Id = item.FAdmissionId;
        }

        else if (attr == 'MotherContact') {
            phone = item.MotherContact;
            DataFrom = 3;
            Id = item.FEnquiryId;
        } else if (attr == 'Mobile') {
            phone = item.Mobile;
            DataFrom = 3;
            Id = item.FEnquiryId;
        }
        console.log("checkwhatsapp ->", phone);
        console.log("DataFrom ->", DataFrom);
        console.log("Id ->", Id);


        let myAlert = this.alertCtrl.create({
            title: 'Check WhatsApp',
            buttons: [
                {
                    text: 'No',
                    role: 'No',
                    handler: (data) => {
                        console.log('No Message clicked');
                        let CheckWhatsApp = 2;
                        this.service.httpcall('app_web_service/check_whatsapp_by_schoolId_data?SchoolId=' + this.SchoolData[this.School] + '&DataFrom=' + DataFrom + '&Id=' + Id + '&PhoneType=' + attr + '&CheckWhatsApp=' + CheckWhatsApp).subscribe(data => {
                            console.log(data);
                            if (data['response'] == "success") {
                                this.presentToast(data['message']);
                                console.log("LabelId->",index+"_"+attr," CSS->",this.get_whatsAppCheck_color(1));
                                var element1 = <HTMLInputElement> document.getElementById(index+"_"+attr);
                                element1.style.background = '#ef5350';
                                // this.WwgsEnquiryData = [];
                                // this.Page = 1;
                                // this.IsSearch = 0;
                                // this.loadDatavalues(this.SchoolData[this.School], this.StandardData[this.Standard], this.Page);
                            } else {
                                this.presentToast(data['error_description']);
                            }
                        })
                    }
                },
                {
                    text: 'Yes',
                    role: 'Yes',
                    handler: (data) => {
                        console.log('Yes Message clicked');
                        let CheckWhatsApp = 1;
                        this.service.httpcall('app_web_service/check_whatsapp_by_schoolId_enquiry?SchoolId=' + this.SchoolData[this.School] + '&DataFrom=' + DataFrom + '&Id=' + Id + '&PhoneType=' + attr + '&CheckWhatsApp=' + CheckWhatsApp).subscribe(data => {
                            console.log(data);
                            if (data['response'] == "success") {
                                this.presentToast(data['message']);
                                console.log(index+"_"+attr);
                                var element2 = <HTMLInputElement> document.getElementById(index+"_"+attr);
                                element2.style.background = '#66bb6a';
                                // this.WwgsEnquiryData = [];
                                // this.Page = 1;
                                // this.IsSearch = 0;
                                // this.loadDatavalues(this.SchoolData[this.School], this.StandardData[this.Standard], this.Page);
                            } else {
                                this.presentToast(data['error_description']);
                            }
                        })
                    }
                }
            ]
        });

        myAlert.present();

    }
    Dataedit(item, attr,index) {
        let phone = null;
        let DataFrom = null;
        let Id = null;
        if (attr == 'Phone1') {
            phone = item.Phone1;
            DataFrom = 1;
            Id = item.Id;
        } else if (attr == 'Phone2') {
            phone = item.Phone2;
            DataFrom = 1;
            Id = item.Id;
        }

        else if (attr == 'PrimaryContact') {
            phone = item.PrimaryContact;
            DataFrom = 2;
            Id = item.FAdmissionId;
        } else if (attr == 'FatherMobile') {
            phone = item.FatherMobile;
            DataFrom = 2;
            Id = item.FAdmissionId;
        } else if (attr == 'MotherMobile') {
            phone = item.MotherMobile;
            DataFrom = 2;
            Id = item.FAdmissionId;
        } else if (attr == 'FatherPhone') {
            phone = item.FatherPhone;
            DataFrom = 2;
            Id = item.FAdmissionId;
        } else if (attr == 'MotherPhone') {
            phone = item.MotherPhone;
            DataFrom = 2;
            Id = item.FAdmissionId;
        }

        else if (attr == 'MotherContact') {
            phone = item.MotherContact;
            DataFrom = 3;
            Id = item.FEnquiryId;
        } else if (attr == 'Mobile') {
            phone = item.Mobile;
            DataFrom = 3;
            Id = item.FEnquiryId;
        }
        console.log("checkwhatsapp ->", phone);
        console.log("DataFrom ->", DataFrom);
        console.log("Id ->", Id);

        let myAlert = this.alertCtrl.create({
            title: 'Edit Number',
            buttons: [
                {
                    text: 'Submit',
                    role: 'Submit',
                    handler: (data) => {
                        console.log(data[0], ' Message clicked');
                        let PhoneNumber = data[0];
                        this.service.httpcall('app_web_service/edit_phone_number_by_schoolId_data?SchoolId=' + this.SchoolData[this.School] + '&DataFrom=' + DataFrom + '&Id=' + Id + '&PhoneType=' + attr + '&PhoneNumber=' + PhoneNumber).subscribe(data => {
                            console.log(data);
                            if (data['response'] == "success") {
                                this.presentToast(data['message']);
                                var element=<HTMLInputElement> document.getElementById(index+"_"+attr+"_Et") ;
                                element.innerHTML=PhoneNumber;
                                // this.WwgsEnquiryData = [];
                                // this.Page = 1;
                                // this.IsSearch = 0;
                                // this.loadDatavalues(this.SchoolData[this.School], this.StandardData[this.Standard], this.Page);
                            } else {
                                this.presentToast(data['error_description']);
                            }
                        })
                    }
                }
            ]
        });

        myAlert.addInput({
            type: 'text',
            label: attr,
            value: phone
        });

        myAlert.present();


    }

    doRefresh(refresher) {
        console.log('Begin async operation', refresher);
        if (this.data == 'Admissions') {
            this.active_erp_standard_tab(this.ErpStandard);
        }
        if (this.data == 'Enquiry') {
            this.active_erp_standard_tab(this.ErpStandard);
        }
        if (this.data == 'Data') {
            this.active_standard_tab(this.ErpStandard);
        }
        setTimeout(() => {
            console.log('Async operation has ended');
            refresher.complete();
        }, 2000);
    }

    presentToast(msg) {
        let toast = this.toastCtrl.create({
            message: msg,
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

    get_whatsAppCheck_color(check) {

        // console.log("check -> ",check)

        if (check == 0) {
            return 'white-color';
        } else if (check ==1) {
            return 'green-color';
        } else if (check ==2) {
            return 'red-color';
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/contact/contact.ts